import defaultState from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const landmark = {
  namespaced: true,
  state: {
    ...defaultState,
  },
  getters,
  mutations,
  actions,
}

export default landmark



// WEBPACK FOOTER //
// ./src/store/landmark/index.js